import backofficeService from '../../api/backoffice'

export default {
  saleByCategory(id, params = {}) {
    return backofficeService.Api().get(`cspApi/saleByCategory/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  profitAndLose(id, params = {}) {
    return backofficeService.Api().get(`cspApi/profitAndLose/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getBatchList(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getBatchList/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getBatch(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getBatch/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getLightStatus(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getLightStatus/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSaleByEmployee(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getSaleByEmployee/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSubCategory(id, params = {}) {
    console.log('getSubCategory', id, params)
    return backofficeService.Api().get(`cspApi/getSubCategory/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getProduct(id, params = {}) {
    
    return backofficeService.Api().get(`cspApi/getProduct/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getRepairList(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getRepairList/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getTax(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getTax/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoices(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getInvoices/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSettings(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getSettings/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  Invoice: {
    getById(id, params = {}) {
      return backofficeService.Api().get(`cspApi/getInvoiceById/${id}`, { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
    getPaymentByInvoiceId(id, params = {}) {
      return backofficeService.Api().get(`cspApi/getInvoicePayment/${id}`, { params })
        .then(response => response.data)
        .catch((error) => { throw error })
    },
  }
}
